import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { type ReactElement, useState } from "react";
import { useTranslation } from "react-i18next";

interface WebPushPermissionPromptDialogProps {
  requestPermission: () => Promise<void>;
}

export function WebPushPermissionPromptDialog({ requestPermission }: WebPushPermissionPromptDialogProps): ReactElement {
  const { t } = useTranslation("notification");
  const [isOpen, setIsOpen] = useState(true);

  return (
    <AlertDialog open={isOpen} onOpenChange={setIsOpen}>
      <AlertDialogContent className="w-[calc(100%-2rem)] sm:w-full">
        <AlertDialogHeader>
          <AlertDialogTitle>{t("PermissionPrompt.Title")}</AlertDialogTitle>
          <AlertDialogDescription>{t("PermissionPrompt.Description")}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{t("PermissionPrompt.NotNow")}</AlertDialogCancel>
          <AlertDialogAction onClick={() => void requestPermission()}>{t("PermissionPrompt.Enable")}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
